import { CountryActionType } from '../../actions/ActionType'

const initialState = {
    loading: false,
    objeckt:[]
}

type action = {
    type: string
    objeckt?: any
}

const CountryReducer = (state = initialState, action: action) => {
    switch (action.type) {
        case CountryActionType.Country_INIT:
            return {
                ...state,
                objeckt:action.objeckt,
                loading: true
            }
        default:
            return state
    }
}

export default CountryReducer
